// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeleteRefundResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeleteRefundResponseDados = boolean;

export type Payroll_DeleteRefundResponse = ApiResponse<Payroll_DeleteRefundResponseDados>;

registerResponseContract('Payroll_DeleteRefundResponse', {})
